import * as UI from "@iyk/ui"

import { AppLink, type AppRoute } from "@iyk/react-router/client"

type ErrorBoundaryProps = {
  message: string
  details: string
  stack?: string
  traceId?: string
  route: AppRoute
}

export const ErrorBoundary = ({ message, details, stack, traceId, route }: ErrorBoundaryProps) => {
  return (
    <main className="h-dvh flex flex-col justify-center items-center gap-4 p-4 relative">
      <UI.Icon.IykLogo className="size-8" />
      <div className="flex flex-col items-center justify-center gap-2 text-center max-w-[360px] mx-auto">
        <h1 className="text-lg">{message}</h1>
        <p className="text-sm text-gray-11">{details}</p>
      </div>

      {stack && (
        <pre className="w-full p-4 overflow-x-auto text-sm">
          <code>{stack}</code>
        </pre>
      )}

      <AppLink className={UI.classForButton({ kind: "solid", size: "sm" })} to={route}>
        Back to Home
      </AppLink>

      {traceId && (
        <div className="absolute bottom-4 flex items-center gap-1">
          <p className="text-xs text-gray-11 font-mono">Trace ID: {traceId}</p>
          <UI.CopyToClipboardButton textToCopy={traceId} kind="ghost" size="sm" />
        </div>
      )}
    </main>
  )
}
